import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import '../../index.scss';
import MapView from './index';
import { GlobalToast } from 'components/GlobalToast';
var MapViewContainer = function () { return (_jsxs(_Fragment, { children: [_jsx(MapView, {}), _jsx(GlobalToast, {})] })); };
export default MapViewContainer;
